import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

import { useContent } from 'hooks';

const ShareCount: FC = () => {
  const content = useContent();
  const { t } = useTranslation();
  const { share_count } = content;

  if (!share_count) {
    return null;
  }

  return (
    <Typography variant="body2" color="primary">
      {t('content:xShare', { count: share_count })}
    </Typography>
  );
};

export default ShareCount;
